<script>
import { list } from '@/api/business/crmCustomerContact'
export default {
  components: {},
  props: {
    customerId: {
      type: [String, Number],
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      options: []
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    // 监听customerId变化，当有值时加载options
    customerId: {
      handler(val) {
        if (!val) {
          this.selectedValue = null
          return
        }
        this.initOptions();
      },
      immediate: true
    }
  },
  mounted() {

  },
  methods: {
    initOptions() {
      if (!this.customerId) {
        return;
      }

      this.loading = true;
      list({
        customerId: this.customerId
      }).then(res => {
        this.options = res.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    onChange(val) {
      this.$emit('change', this.options.find(item => item.id === val))
    }
  }
}
</script>

<template>
  <el-select
    v-model="selectedValue"
    :loading="loading"
    v-bind="$attrs"
    @change="onChange"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.contactName"
      :value="item.id"
    >
      <span style="float: left">{{ item.contactName }}</span>
      <span style="float: right">{{ item.contactPhone }}</span>
    </el-option>
  </el-select>
</template>

<style lang="scss" scoped></style>
